export default "__VITE_ASSET__BQUZWpYT__"